// 利用規約のURL
export const TERM_URL = 'https://www.notion.so/colorfully/bb175bfaa4ab4e879be97a1bb5e94d26?pvs=4';
// 個人情報に関する告知文のURL
export const PRIVACY_POLICY_URL = 'https://www.notion.so/colorfully/b388600a070c4b8c9ec9c026bb6c2337?pvs=4';
// お問い合わせのURL
export const INQUIRY_URL = 'https://form.run/@colorfullyme-inquiry';
